export default "__VITE_ASSET__B$kPxKy___"